import { useRef, type CSSProperties, type DependencyList, type ReactNode } from 'react';
import { useFitHeight } from '../lib/fitHeight';
import { TopScrollbar } from './TopScrollbar';

/**
 * 손수 만든 표의 목록 상자(10-16 way 「모든 화면 — 내리면 머리글 고정 · 위칸 최소 · 아래 최대 · 가로 스크롤」).
 *
 * `DataTable` 이 하던 세 가지를 손수 만든 표에도 똑같이 준다:
 *  ① 높이를 화면에 맞춘다(`useFitHeight`) — 상자 안만 움직이고 페이지는 안 움직인다 → 가로 스크롤 막대가 늘 화면 안에 있다.
 *  ② 머리글(`thead`)을 상자 위에 붙인다 — `.fit-box` CSS(globals.css). 칸 배경도 거기서 칠한다(sticky thead 는 제 배경을 안 칠한다).
 *  ③ 표 위에 가로 스크롤 막대(`TopScrollbar` · #249) — 표가 화면보다 넓을 때만 뜬다.
 *
 * `deps` = 표 줄 수처럼 상자 아래 내용(쪽 넘김 줄)을 바꾸는 값. 팝업·패널 안의 작은 표엔 쓰지 않는다(그쪽은 제 높이가 있다).
 */
export function FitBox({ children, deps = [], min, className = 'card', style }: {
  children: ReactNode;
  deps?: DependencyList;
  min?: string;
  className?: string;
  style?: CSSProperties;
}) {
  const ref = useRef<HTMLDivElement>(null);
  const maxHeight = useFitHeight(ref, deps, min ? { min } : undefined);
  return (
    <>
      <TopScrollbar target={ref} />
      <div ref={ref} className={`fit-box overflow-auto ${className}`} style={{ ...style, maxHeight }}>
        {children}
      </div>
    </>
  );
}
